import type { TCommunityStats, TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

export const useGetCommunityStatsQueryKey = (spaceId: string) => [ENTITY, 'widgets', spaceId, 'stats'];

/**
 * Hook to fetch community stats for a space: total members of the space's app
 * and posts created in the last 7 days.
 *
 * @param spaceId - Feed space ID (UUID)
 */
export const useGetCommunityStats = (spaceId: string) => {
  return useQuery<TCommunityStats, TError>({
    queryKey: useGetCommunityStatsQueryKey(spaceId),
    queryFn: async () => {
      const res = await axios.get<TCommunityStats>(`/community-hub/spaces/${spaceId}/widgets/stats`);
      return res.data;
    },
    enabled: !!spaceId,
    staleTime: 5 * 60 * 1000, // 5 minutes — matches the API-side cache window
  });
};
